"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTLQueue = void 0;
const SlidingWindow_1 = require("./SlidingWindow");
class TTLQueue {
    timeToLive;
    queue;
    constructor(capacity, timeToLive) {
        this.queue = new SlidingWindow_1.SlidingWindow(capacity);
        this.timeToLive = timeToLive;
    }
    push(item) {
        this.queue.push({ timestamp: Date.now(), item });
        this.clean();
    }
    shift() {
        this.clean();
        const entry = this.queue.shift();
        return entry ? this.unwrap(entry) : entry;
    }
    peekFront() {
        this.clean();
        const entry = this.queue.peekFront();
        return entry ? this.unwrap(entry) : entry;
    }
    toArray() {
        this.clean();
        const entries = this.queue.toArray();
        return entries.length ? entries.map(this.unwrap) : [];
    }
    unwrap(entry) {
        return entry?.item;
    }
    remove(index, count) {
        return this.queue.remove(index, count);
    }
    clean() {
        const now = Date.now();
        let next = this.queue.peekFront();
        while (next && next.timestamp + this.timeToLive < now) {
            this.queue.shift();
            next = this.queue.peekFront();
        }
    }
}
exports.TTLQueue = TTLQueue;
//# sourceMappingURL=TTLQueue.js.map